import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f818d45")

_pushScopeId("data-v-0f818d45")
const _hoisted_1 = { class: "d-none d-lg-flex filter-row" }
const _hoisted_2 = {
  class: "d-flex",
  style: {"max-width":"432px","width":"100%"}
}
const _hoisted_3 = { class: "search-button-wrapper pl-15" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_5 = { class: "show-all-clear-filter align-items-lg-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "orders-filter-circle"
}
const _hoisted_8 = {
  class: "order-products-total order-lg-1",
  style: {"height":"48px"}
}
const _hoisted_9 = { class: "d-lg-none d-flex mobile-filter-row" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "search-button-wrapper pl-15" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_13 = {
  class: "d-flex",
  style: {"padding-bottom":"15px","flex-wrap":"wrap","row-gap":"10px"}
}
const _hoisted_14 = {
  class: "order-products-total order-lg-1",
  style: {"height":"48px","white-space":"nowrap"}
}
const _hoisted_15 = { class: "show-all-clear-filter align-items-lg-center" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "orders-filter-circle"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "mobile-grid w-100"
}
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "title" }
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "title" }
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "title" }
const _hoisted_32 = { class: "value" }
const _hoisted_33 = { class: "title" }
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "title" }
const _hoisted_36 = { class: "value" }
const _hoisted_37 = {
  key: 1,
  class: "desktop-grid table w100"
}
const _hoisted_38 = { class: "w100" }
const _hoisted_39 = { class: "desktop-table-text-setting is-link" }
const _hoisted_40 = { class: "desktop-table-text-setting" }
const _hoisted_41 = { class: "desktop-table-text-setting is-link" }
const _hoisted_42 = { class: "desktop-table-text-setting is-link" }
const _hoisted_43 = { class: "desktop-table-text-setting" }
const _hoisted_44 = { class: "desktop-table-text-setting" }
const _hoisted_45 = { class: "desktop-table-text-setting" }
const _hoisted_46 = { class: "desktop-table-text-setting" }
const _hoisted_47 = { class: "desktop-table-text-setting" }
const _hoisted_48 = { class: "desktop-table-text-setting" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CustomLoader = _resolveComponent("CustomLoader")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", {
    class: ["businessClients-table-container container", { 'businessClients-table-container-mobile': _ctx.isMobile }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _withDirectives(_createVNode("input", {
          class: "bookit-input order-input w100",
          id: "datetime",
          type: "text",
          placeholder: _ctx.$t('placeholder.businessOrderProducts'),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.keyword = $event))
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.filter.keyword]
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, [
            _hoisted_4
          ])
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("span", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
        }, _toDisplayString(_ctx.$t('button.showAll')), 1)
      ]),
      _createVNode("div", {
        class: ["businessClients-filter", { hasFilter: _ctx.hasFilter }]
      }, [
        _createVNode("button", {
          type: "button",
          class: "orders-filter-btn-text",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showFilter && _ctx.showFilter(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
          _hoisted_6
        ]),
        (_ctx.hasFilter)
          ? (_openBlock(), _createBlock("div", _hoisted_7, "!"))
          : _createCommentVNode("", true)
      ], 2),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", null, _toDisplayString(_ctx.$t('businessClients.totalOrders')), 1),
        _createVNode("div", null, _toDisplayString(_ctx.totalFiltered) + " " + _toDisplayString(_ctx.$t('businessClients.ofOrders', { total: _ctx.total })), 1)
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _withDirectives(_createVNode("input", {
          class: "bookit-input order-input w100",
          id: "datetime",
          type: "text",
          placeholder: _ctx.$t('placeholder.businessOrderProducts'),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter.keyword = $event))
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.filter.keyword]
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, [
            _hoisted_12
          ])
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('businessClients.totalOrders')), 1),
          _createVNode("div", null, _toDisplayString(_ctx.totalFiltered) + " " + _toDisplayString(_ctx.$t('businessClients.ofOrders', { total: _ctx.total })), 1)
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("span", {
            style: {"white-space":"nowrap"},
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
          }, _toDisplayString(_ctx.$t('button.showAll')), 1)
        ]),
        _createVNode("div", {
          class: ["businessClients-filter", { hasFilter: _ctx.hasFilter }]
        }, [
          _createVNode("button", {
            type: "button",
            class: "orders-filter-btn-text",
            style: {"display":"flex","align-items":"center"},
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showFilter && _ctx.showFilter(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
            _hoisted_16
          ]),
          (_ctx.hasFilter)
            ? (_openBlock(), _createBlock("div", _hoisted_17, "!"))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_CustomLoader, { key: 0 }))
      : (_openBlock(), _createBlock("div", _hoisted_18, [
          (_ctx.isMobile)
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderProducts, (product, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "mobile-order-product-item",
                    key: index
                  }, [
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('label.orderId')) + ": ", 1),
                      _createVNode(_component_router_link, {
                        class: "value is-link c-pointer",
                        to: {
                                name: 'order',
                                params: { id: product.hashOrderId }
                            }
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(product.orderId), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('label.customer_name')) + ": ", 1),
                      _createVNode("span", _hoisted_22, _toDisplayString(product.customerName), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('label.coupon-name')) + ": ", 1),
                      _createVNode(_component_router_link, {
                        class: "value is-link c-pointer",
                        to: {
                                name: 'coupon-edit',
                                params: { couponId: product.couponId }
                            }
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(product.couponName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('product.productName')) + ": ", 1),
                      _createVNode(_component_router_link, {
                        class: "value is-link c-pointer",
                        to: {
                                name: 'product',
                                params: { id: product.productId, tab: 1 }
                            }
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(product.productName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('priceList.customType')) + ": ", 1),
                      _createVNode("span", _hoisted_26, _toDisplayString(product.customerTypeName), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('accounting.total')) + ": ", 1),
                      _createVNode("span", _hoisted_28, [
                        _createVNode("span", null, _toDisplayString(_ctx.formatAmount(product.businessClientTotalAmount)) + _toDisplayString(product.localCurrencySymbol), 1)
                      ])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('label.invoices')) + ": ", 1),
                      _createVNode("span", _hoisted_30, _toDisplayString(_ctx.formatAmount(product.invoices)), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('orders.paid')) + ": ", 1),
                      _createVNode("span", _hoisted_32, _toDisplayString(_ctx.formatAmount(product.paid)), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('orders.balance')) + ": ", 1),
                      _createVNode("span", _hoisted_34, _toDisplayString(_ctx.formatAmount(product.balance)), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('label.created-date')) + ": ", 1),
                      _createVNode("span", _hoisted_36, _toDisplayString(product.createdDate), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_37, [
                _createVNode("table", _hoisted_38, [
                  _createVNode("thead", null, [
                    _createVNode("tr", null, [
                      _createVNode("td", {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sotrBy('OrderId')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.orderId')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('OrderId')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sotrBy('CustomerName')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.customer_name')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CustomerName')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sotrBy('CouponName')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.coupon-name')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CouponName')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sotrBy('ProductName')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('product.productName')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProductName')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sotrBy('CustomerType')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('priceList.customType')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CustomerType')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sotrBy('Total')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('accounting.total')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Total')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sotrBy('Invoices')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.invoices')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Invoices')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sotrBy('Paid')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('orders.paid')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Paid')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sotrBy('Balance')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('orders.balance')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Balance')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sotrBy('CreatedDate')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.created-date')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CreatedDate')]
                          }, null, 2)
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderProducts, (product, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: index,
                        style: {"position":"relative"}
                      }, [
                        _createVNode("td", _hoisted_39, [
                          _createVNode("span", null, [
                            _createVNode(_component_router_link, {
                              to: {
                                            name: 'order',
                                            params: { id: product.hashOrderId }
                                        }
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(product.orderId), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]),
                        _createVNode("td", _hoisted_40, [
                          _createVNode("span", null, _toDisplayString(product.customerName), 1)
                        ]),
                        _createVNode("td", _hoisted_41, [
                          _createVNode("span", null, [
                            _createVNode(_component_router_link, {
                              to: {
                                            name: 'coupon-edit',
                                            params: { couponId: product.couponId }
                                        }
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(product.couponName), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]),
                        _createVNode("td", _hoisted_42, [
                          _createVNode("span", null, [
                            _createVNode(_component_router_link, {
                              to: {
                                            name: 'product',
                                            params: { id: product.productId, tab: 1 }
                                        }
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(product.productName), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]),
                        _createVNode("td", _hoisted_43, [
                          _createVNode("span", null, _toDisplayString(product.customerTypeName), 1)
                        ]),
                        _createVNode("td", _hoisted_44, [
                          _createVNode("span", null, _toDisplayString(_ctx.formatAmount(product.businessClientTotalAmount)) + _toDisplayString(product.localCurrencySymbol), 1)
                        ]),
                        _createVNode("td", _hoisted_45, [
                          _createVNode("span", null, _toDisplayString(_ctx.formatAmount(product.invoices)), 1)
                        ]),
                        _createVNode("td", _hoisted_46, [
                          _createVNode("span", null, _toDisplayString(_ctx.formatAmount(product.paid)), 1)
                        ]),
                        _createVNode("td", _hoisted_47, [
                          _createVNode("span", null, _toDisplayString(_ctx.formatAmount(product.balance)), 1)
                        ]),
                        _createVNode("td", _hoisted_48, [
                          _createVNode("span", null, _toDisplayString(product.createdDate), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
        ]))
  ], 2))
})